import { render, staticRenderFns } from "./ServiceRequestForms.vue?vue&type=template&id=2e88021c&scoped=true&"
import script from "./ServiceRequestForms.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestForms.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestForms.vue?vue&type=style&index=0&id=2e88021c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88021c",
  null
  
)

export default component.exports